module.exports = __webpack_public_path__ + "img/bot_1.8a23660a.png";